import {
    applyMiddleware,
    compose,
    routerMiddlewareWithHistory,
    createSagaMiddleware,
    sentryReduxEnhancer,
    Config,
    Log,
    Consts,
} from '../dependencies';

export default function configureEnhancer() {
    const sagaMiddleware = createSagaMiddleware({
        onError: Log.error,
    });

    const middlewares = [routerMiddlewareWithHistory, sagaMiddleware];
    const enhancerArgs = [applyMiddleware(...middlewares), sentryReduxEnhancer];

    if (Config.devTools && !Consts.isServerEnv) {
        // eslint-disable-next-line
        const reduxDevTools = window.__REDUX_DEVTOOLS_EXTENSION__;
        if (reduxDevTools) {
            enhancerArgs.push(reduxDevTools());
        }
    }

    return {
        enhancer: compose(...enhancerArgs),
        sagaMiddleware,
    };
}
